import { render, staticRenderFns } from "./SiatNotificheListaComponent.vue?vue&type=template&id=69bf6baa&scoped=true"
import script from "./SiatNotificheListaComponent.vue?vue&type=script&lang=js"
export * from "./SiatNotificheListaComponent.vue?vue&type=script&lang=js"
import style0 from "./SiatNotificheListaComponent.vue?vue&type=style&index=0&id=69bf6baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bf6baa",
  null
  
)

export default component.exports